import * as React from 'react';

export type TestsData = {
  [localRelPath: string]: string;
};

export type State = {
  testsData1?: TestsData;
  testsData2?: TestsData;
};

export default class VisTestsCompare extends React.Component<
  {
    devDirUrl1: string;
    devDirUrl2: string;
  },
  State
> {
  state: State = {};
  componentDidMount() {
    fetch(`${this.props.devDirUrl1}/vis-tests.json`)
      .then(req => req.json())
      .then(json => this.setState({testsData1: json}));

    fetch(`${this.props.devDirUrl2}/vis-tests.json`)
      .then(req => req.json())
      .then(json => this.setState({testsData2: json}));
  }
  render() {
    if (!this.state.testsData1 || !this.state.testsData2) {
      return <div>загрузка...</div>;
    }
    const allKeys = Array.from(
      new Set([...Object.keys(this.state.testsData1), ...Object.keys(this.state.testsData2)]),
    ).filter(s => !s.endsWith('.json'));
    const baseUrl = `https://yastatic.net/s3/milab/2021/old-words/front-v1/vis-tests/shots/`;
    return (
      <div>
        {allKeys.map(key => {
          const imgRelSrc1 = this.state.testsData1![key];
          const imgRelSrc2 = this.state.testsData2![key];
          if (imgRelSrc1 === imgRelSrc2) return null;
          const imgSrc1 = imgRelSrc1 ? baseUrl + imgRelSrc1 : null;
          const imgSrc2 = imgRelSrc2 ? baseUrl + imgRelSrc2 : null;
          return (
            <>
              <div style={{textAlign: 'center'}}>
                {key
                  .split('.')
                  .slice(0, -1)
                  .join('.')}
              </div>
              <div key={key} style={{display: 'flex'}}>
                <div style={{width: '50%'}}>
                  {imgSrc1 ? (
                    <img
                      src={imgSrc1}
                      style={{width: '50vw', height: '50vw', objectFit: 'contain'}}
                      alt=""
                    />
                  ) : null}
                </div>
                <div style={{width: '50%'}}>
                  {imgSrc2 ? (
                    <img
                      src={imgSrc2}
                      style={{width: '50vw', height: '50vw', objectFit: 'contain'}}
                      alt=""
                    />
                  ) : null}
                </div>
              </div>
            </>
          );
        })}
      </div>
    );
  }
}
